// MoneyZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import MoneyZakatTable from './MoneyZakatTable';
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Money_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = `Kalkulator Zakat Harta 2026 - Kalkulator Nisab Zakat Harta`;
const DESCRIPTION = 'Kalkulator Zakat Harta adalah alat yang digunakan untuk menghitung zakat harta dan nisab zakat harta atas uang tunai, tabungan, dan investasi.';
const KEYWORDS = 'zakat harta, jumlah zakat harta, nisab zakat, zakat atas harta, kalkulator zakat harta, zakat, perhitungan zakat harta, nisab zakat harta';
const OG_URL = 'https://do-calculate.com/calculator/id/money-zakat/';
const apiEndpoint = `${SERVER_URL}/${Money_Zakat_EndPoint}`;
function MoneyZakatCalculator() {
    const [amount, setAmount] = useState('');
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [thresholdType, setThresholdType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const handleThresholdTypeChange = (event) => {
        const newThresholdType = event.target.value;
        setThresholdType(newThresholdType);
        if (newThresholdType === "gold") {
            setGramPriceSilver(0);
        } else if (newThresholdType === "silver") {
            setGramPriceGold(0);
        }
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateMoneyZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ amount, yearType, gramPriceGold, gramPriceSilver }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div >
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Hitung Zakat Harta</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Kalkulator Zakat Harta adalah alat yang digunakan untuk menghitung jumlah zakat yang wajib dikeluarkan atas uang tunai, tabungan, dan investasi serta menghitung nisab zakat harta dan jumlah zakat harta yang wajib dikeluarkan. Kalkulator dirancang dengan mempertimbangkan nilai harta yang dimiliki, jenis tahun (Hijriah atau Masehi), dan harga emas dan perak untuk menghitung batas minimum harta yang terkena zakat.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Kalkulator Zakat Harta</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Jenis Tahun</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gregorianRadio"
                                            name="yearType"
                                            value="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorianRadio">
                                            Masehi
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="hijri"
                                            name="yearType"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijriah
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="amoutNumber" className="form-label ms-2" >Total Harta</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="amoutNumber"
                                        value={amount}
                                        onChange={handleAmountChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Jenis Nisab</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gold"
                                            name="thresholdType"
                                            value="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            Emas
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="silver"
                                            name="thresholdType"
                                            value="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            Perak
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver == 0}
                                        <b>
                                            <label className="form-label ms-2">Harga gram emas (24 karat)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold == 0}
                                        <b>
                                            <label className="form-label ms-2">Harga gram perak (kadar 99.9)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateMoneyZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Hitung'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Terjadi kesalahan :</u></b> Harap isi semua bidang dengan benar. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Hasil: </div></h4>
                                            <hr />
                                            <MoneyZakatTable result={result}></MoneyZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Deskripsi Kalkulator Zakat Harta</div>
                            <div className="info-section-body">
                                <div>
                                    <h2 style={{ fontSize: '15px' }}>Nisab Zakat Harta - Jumlah Zakat yang Wajib</h2>
                                    <p>
                                        Kalkulator Zakat Harta didasarkan pada perhitungan nisab zakat sesuai dengan standar syariah Islam. Misalnya, dalam zakat Hijriah, nisab adalah harta yang setara dengan nilai 85 gram emas, dan dalam zakat Masehi, nisab adalah harta yang setara dengan nilai 595 gram perak. Jika nilai harta yang Anda miliki melebihi nisab ini, maka Anda wajib mengeluarkan zakat.
                                    </p>
                                    <br />
                                    <h2 style={{ fontSize: '15px' }}>Cara Menghitung Zakat Harta</h2>
                                    <p>
                                        Kalkulator menghitung jumlah zakat yang wajib dikeluarkan berdasarkan nilai yang dimasukkan oleh pengguna, sesuai dengan ketentuan syariah Islam. Jika nilai harta melebihi nisab yang ditentukan berdasarkan tahun dan harga emas atau perak, kalkulator menghitung persentase zakat yang ditetapkan, yaitu 2.5% untuk zakat Hijriah dan 2.577% untuk zakat Masehi. Setelah itu, menentukan status zakat apakah wajib ("Ya") dan menghitung jumlah uang yang wajib dibayarkan.
                                    </p>
                                    <p>
                                        Kalkulator menyajikan hasilnya dalam bentuk laporan yang mencakup status zakat ("Ya" atau "Tidak"), jumlah yang wajib dikeluarkan, dan nilai minimum harta yang terkena zakat.
                                    </p>
                                    <br />
                                    <div className='p-3 mb-2 bg-info'>
                                    Emas yang dijadikan acuan dalam menentukan nisab zakat adalah emas 24 karat; karena emas 21 atau 18 karat bukanlah emas murni, melainkan bercampur dengan logam dan mineral lainnya. Barangsiapa memiliki emas dengan karat lain seperti 22, 21, 18, 14, 10 atau lainnya, maka zakat hanya wajib atas bagian yang murni saja.
                                    </div>
                                    <p>
                                        Kalkulator ini dapat digunakan di semua negara Arab, termasuk:
                                    </p>
                                    <ul>
                                        <li>Kerajaan Arab Saudi</li>
                                        <li>Uni Emirat Arab</li>
                                        <li>Kuwait</li>
                                        <li>Bahrain</li>
                                        <li>Qatar</li>
                                        <li>Oman</li>
                                        <li>Yordania</li>
                                        <li>Mesir</li>
                                        <li>Irak</li>
                                        <li>Lebanon</li>
                                        <li>Suriah</li>
                                        <li>Palestina</li>
                                        <li>Yaman</li>
                                        <li>Maroko</li>
                                        <li>Aljazair</li>
                                        <li>Tunisia</li>
                                        <li>Libya</li>
                                    </ul>
                                    <br />
                                    <hr />
                                    <b>Sumber: </b>
                                    <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">
                                        Islamic Relief Worldwide
                                    </a>
                                    <br />
                                    <b>Tanggal revisi terakhir:</b> 28/02/2026
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MoneyZakatCalculator;